import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processPleasureUseData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
  remarks: Remark[],
  validation?: Validation,
): BinderSectionData => {
  const processedPleasureUseData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const isPleasure = vehicle?.is_pleasure || false;
      const commuteKm = vehicle?.commute_one_way || 0;
      const isValid = validateFailedObjects(index, validation);

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        isPleasure,
        commuteKm,
        remarks: remarks.find((r) => r.item_key === `vehicle-${index + 1}`)
          ?.text,
        isValid,
      };
    }),
  };

  const validationData = processValidation(validation);

  return {
    title: 'Pleasure use',
    description: 'Check vehicle usage classification for each vehicle.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: processedPleasureUseData,
  };
};
